const ANALYTICS_CATEGORY = 'global_banner'

// Mirrors the dotcom `analytics_visible_attributes(category:, text:)` helper output.
export function visibleAnalytics(uid: string): string {
  return JSON.stringify({category: ANALYTICS_CATEGORY, action: 'visible', label: `text: ${uid}`})
}

// Mirrors `analytics_click_attributes(**analytics_tags_from_content(analytics: {category, action: uid}, text: title))`.
export function linkClickAnalytics(uid: string, title?: string): string {
  return JSON.stringify({category: ANALYTICS_CATEGORY, action: uid, label: `ref_cta:${title ?? ''};`})
}

// Mirrors the dismiss `analytics_click_attributes(category:, action: "Dismiss global_banner_<uid>")` output.
export function dismissAnalytics(uid: string): string {
  return JSON.stringify({category: ANALYTICS_CATEGORY, action: `Dismiss global_banner_${uid}`, label: null})
}
